import {renderHeader} from './components/header.js';
import {renderFooter} from './components/footer.js';
import {renderRobot} from './components/robot.js';
import {renderReaderPicker} from './components/reader-picker.js';
import {renderProductPromo} from './components/product-promo.js';

/**
 * Render the Reader landing page into the supplied root element.
 * Mirrors the previous `<App/>` React component structure exactly:
 * header, main content box (Snappbot + reader picker), footer.
 */
export function renderApp(root) {
    root.innerHTML = `
        <div class="App">
            ${renderHeader()}
            <section class="main-container" style="flex-grow: 1">
                <div class="main-container__bg" aria-hidden="true"></div>
                <div class="container">
                    <div class="main-content-box">
                        <div class="row">
                            ${renderRobot()}
                            <div class="col-12 col-md-8 col-lg-8" data-slot="reader-picker"></div>
                        </div>
                        ${renderProductPromo()}
                    </div>
                </div>
            </section>
            ${renderFooter()}
        </div>
    `;

    // The reader picker queries the live navigator + writes into its slot —
    // keeps detection out of the static template-string layer above.
    const slot = root.querySelector('[data-slot="reader-picker"]');
    if (slot) renderReaderPicker(slot);
}
